<app-navbar-style-two></app-navbar-style-two>
<app-seo-agency></app-seo-agency>


<section class="pt-5">
    <div class=" container-fluid contact-banner mt-5">
        <h2 style="color: #ffffff;">Contact Us</h2>
        <p style="color: #ffffff;">Drop us Message for any Query</p>
    </div>
</section>

<section class="py-5">
    <div class="container pt-5 pb-5" style="box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);">
      <div class="row g-4">
        <!-- Left Column -->
        <div class="col-lg-6">
          <h4 class="fw-bold mb-3">Why Choose RingPilot</h4>
          <p>Take the first steps towards increased productivity and enhanced communication with RingPilot.</p>
          <p>We are a highly trained, dedicated team, helping businesses, contact centers, and sales organizations streamline success - 
            not just in work, but in customer relationships too. We help spare your time to focus on the bigger picture by taking care of
             your communication infrastructure and customer engagement.
          </p>
          <ul class="list-unstyled text-success">
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>24/7 US-based customer support</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Flexible plans that grow with your business </li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>No long-term contracts required</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Industry-specific solutions for your unique needs</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Hire based on specific industry or technical expertise</li>
          </ul>
        </div>
  
        <!-- Right Column - Form -->
        <div class="col-lg-6">
          <h4 class="fw-bold mb-3">Let's Start Your Free Trial</h4>
          <form>
            <div class="row mb-0">
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" placeholder="Your Name">
              </div>
              <div class="col-md-6 mb-3">
                <input type="email" class="form-control" placeholder="Your Email">
              </div>
            </div>
            <div class="row mb-0">
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" placeholder="Your Phone">
              </div>
              <div class="col-md-6 mb-3">
                <input type="email" class="form-control" placeholder="Your Subject">
              </div>
            </div>
            <div class="mb-0">
              <textarea class="form-control" rows="4" placeholder="Your Message"></textarea>
            </div>
            <button class="btn start-btn fw-bold d-flex align-items-center justify-content-center mt-3 px-4">
                <i class="bi bi-send-fill me-1"></i> Send Message
            </button>              
          </form>
        </div>
      </div>
  
      <!-- Contact Details -->
      <div class="text-center mt-5">
        <p class="fw-bold">Contact us by Phone Number or Email Address</p>
        <h4 class="text-success fw-bold mb-1">+1 630 396 0967</h4>
        <h5 class="text-danger fw-semibold">info@ringpilot.com</h5>
        <div class="mt-3">
          <a href="#" class="text-dark me-3"><i class="bi bi-twitter fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-youtube fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-facebook fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-linkedin fs-5"></i></a>
          <a href="#" class="text-dark"><i class="bi bi-instagram fs-5"></i></a>
        </div>
      </div>
    </div>
  </section>


<app-footer-style-two></app-footer-style-two>